import React, { useState, useEffect, useContext } from 'react';
import './FacilityReports.css';
import { Link } from 'react-router-dom';
import { CardReportsContext } from '../../contexts/CardReportsContext';
import logComponent from '../../common/logComponent';

export default function FacilityReportsContent() {
  const cardReportsContext = useContext(CardReportsContext);
  const [contentData, setContentData] = useState(null);

  if (logComponent('FacilityReportsContent')) { console.debug('FacilityReportsContent rendered'); }

  useEffect(() => {
    if (logComponent('FacilityReportsContent')) { console.debug('FacilityReportsContent useEffect [cardReportsContext.reports]'); }
    setContentData(cardReportsContext.reports ? [...cardReportsContext.reports] : null);
  }, [cardReportsContext.reports]);

  return (contentData
     && contentData.length > 0 ?
      <ul className="Facility-Reports__list">
        {contentData &&
          contentData.map(report => {
            return report.listingName !== 'Device Details' ?
              <li className="Facility-Reports__list-item" key={report.reportId}>
                <Link
                  to={`/reports/${report.reportId}`}
                  className="Facility-Reports__link"> {report.linkText}</Link>
              </li> :
              <li className="Facility-Reports__list-item" key={report.linkText}>
                <Link
                  to="/devices"
                  className="Facility-Reports__link"> {report.linkText}</Link>
              </li>
          })
        }
      </ul> :
      <p className="Facility-Reports__empty-message">No reports found</p>);
}